import React, { useEffect } from "react"
import { navigate } from "gatsby"

const NotFoundPage = () => {
  useEffect(() => {
    navigate("/")
  }, [])
  return <main></main>
}

export default NotFoundPage

export const Head = () => <title>Not found</title>
